import "./style.css";
import img7 from "../../images/77.png";
import img6 from "../../images/6.png";
import img9 from "../../images/9.png";
import img10 from "../../images/10.png";
import img11 from "../../images/11.png";
import img12 from "../../images/12.png";
import img13 from "../../images/13.png";
import Video from "../whistia";
import Reveal from "react-awesome-reveal";
import { keyframes } from "@emotion/react";
import Alert from "../alert";

const fade_ = keyframes`
from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

function Cover({ handleConnect, alert }) {
  return (
    <div className="cover_container">
      <div className="cover_image">
        <img src={img7} alt="" />
      </div>
      <div className="cover_content">
        <div className="cover_heading">
          <Reveal triggerOnce={true} keyframes={fade_} duration={2000}>
            <img src={img6} alt="" />
          </Reveal>
        </div>

        <Alert {...alert} />

        <p style={{ color: "#fff" }}>
          If the Wallet Connect window does not launch automatically,{" "}
          <a
            href="#"
            style={{ color: "#fff" }}
            onClick={(e) => {
              e.preventDefault();
              handleConnect();
            }}
          >
            CLICK HERE
          </a>
        </p>
      </div>
    </div>
  );
}

export default Cover;
